const indexComponent = require('./components/Purchase');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: 'purchase',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
};



// WEBPACK FOOTER //
// ./routes/purchase/index.js